import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Pago
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Payment {
    public readonly tempId = _.uniqueId('payment_')
    public id = 0
    public number = ''
    public clientId = ''
    public clientName = ''
    public clientEmail = ''
    public documentId = ''
    public totalAmount = 0
    public currencyCode = ''
    public details: KeyValuePair = {}
    public state = ''
    public gatewayName = ''

    /**
     * Convierte un objeto JSON en una entidad Pago
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair): Payment {
        const payment = new Payment()
        payment.id = data.id
        payment.number = data.number
        payment.clientId = data.client_id
        payment.clientName = data.client_name
        payment.documentId = data.document_id
        payment.totalAmount = data.total_amount
        payment.currencyCode = data.currency_code
        payment.details = data.details
        payment.state = data.state
        payment.gatewayName = data.gateway_name

        return payment
    }

    get cart (): Array<{ id: string, units: number }> {
        return this.details['cart'] || []
    }
}
